import * as React from 'react';
import {
    List,
    DatagridConfigurable,
    TextField,
    DateField,
    DateInput,
    TopToolbar,
    ExportButton,
    SelectColumnsButton,
    ReferenceInput,
    FilterButton,
    CreateButton,
    useRecordContext,
} from 'react-admin';

const ListActions = () => (
    <TopToolbar>
        {/*<FilterButton />*/}
        <CreateButton />
        <SelectColumnsButton />
        <ExportButton />
    </TopToolbar>
);

const DataSetList = () => (
    <div style={{ marginTop: '20px' }}>
        <List
            // filters={listFilters}
            perPage={25}
            actions={<ListActions />}
        >
            <DatagridConfigurable
                rowClick="show"
                // expand={<InvoiceShow />}
                sx={{
                    '& .column-tenant': {
                        display: { xs: 'none', md: 'table-cell' },
                    },
                }}
            >
                <TextField source="metadata.name" label="resources.datasets.form.name" />
                <TextField source="spec.type" label="resources.datasets.form.type" />
                <TextField source="spec.catalog" label="resources.datasets.form.catalog" />
                <DateField 
                    source="metadata.creationTimestamp" 
                    label="Creation Time"
                    showTime
                    options={{
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                        hour: '2-digit',
                        minute: '2-digit',
                        second: '2-digit',
                        hour12: false,
                    }}
                />
            </DatagridConfigurable>
        </List>
    </div>
);

export default DataSetList;
